import Vue from 'vue'
import router from '../router/router'
/**
 * 邮箱
 * @param {*} s
 */
export function isEmail(s) {
    return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
    return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
    return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
    return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 正整数
 * @param {*} s
 */
export function isNumber(s) {
    return /^\+?[1-9][0-9]*$/.test(s)
}

// 动态获取日期
export function getDynamicTime(type, num, datetime) {
    let date
    if (datetime) {
        date = new Date(datetime)
    } else {
        date = new Date()
    }
    if (type == 'month') {
        let date1 = date
        let Y = date1.getFullYear()
        let M = date1.getMonth() + 1
        if (num >= 0) {
            let years = parseInt((M + num) / 13)
            Y = Y + years
            M = M + num - years * 12
        } else {
            let years = M + num > 0 ? 0 : parseInt((M + num) / 12) - 1
            Y = Y + years
            M = M + num - years * 12
        }
        return Y + '-' + (M < 10 ? '0' + M : M)
    } else if (type == 'date') {
        let date2 = new Date(date.getTime() + num * 24 * 3600 * 1000)
        let Y = date2.getFullYear()
        let M = date2.getMonth() + 1
        let D = date2.getDate()
        return Y + '-' + (M < 10 ? '0' + M : M) + '-' + (D < 10 ? '0' + D : D)
    } else if (type == 'datetime') {
        let date3 = new Date(date.getTime() + num * 24 * 3600 * 1000)
        let Y = date3.getFullYear()
        let M = date3.getMonth() + 1
        let D = date3.getDate()
        let H = date3.getHours()
        let m = date3.getMinutes()
        return (
            Y +
            '-' +
            (M < 10 ? '0' + M : M) +
            '-' +
            (D < 10 ? '0' + D : D) +
            ' ' +
            (H < 10 ? '0' + H : H) +
            ':' +
            (m < 10 ? '0' + m : m)
        )
    }
}

// 获取当前是周几
export function getWeekDate(date) {
    let day = new Date(date).getDay()
    let weeks = new Array('周日', '周一', '周二', '周三', '周四', '周五', '周六')
    return weeks[day]
}

//获取当前年
export function getYear() {
    let nowdate = new Date()
    let nowy = nowdate.getFullYear()
    return nowy
}

// 月份转化为日期范围
export function toMonthRange(month) {
    // 这个月
    let nowdate = new Date()
    let nowy = nowdate.getFullYear()
    let nowm = nowdate.getMonth() + 1
    let mored = nowdate.getDate()
    // 指定月
    let date = new Date(month)
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    let date2 = new Date(y, m, 0)
    let days = date2.getDate() // 天数
    if (nowm < m || nowy != y) {
        return { begin: month + '-01', end: month + '-' + days }
    } else if (nowm == m && nowy == y) {
        return { begin: month + '-' + (mored < 10 ? '0' + mored : mored), end: month + '-' + days }
    }
}

// 禁用小于当前月份（判断当前是不是月的最后一天）
export function monthDisabled(time) {
    // 当前月份信息
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let d = date.getDate()
    if (month >= 1 && month <= 9) {
        month = '0' + month
    }
    let nowDate = year.toString() + month.toString()
    // 获取时间选择器的月份信息
    let Y = time.getFullYear()
    let M = time.getMonth() + 1
    if (M >= 1 && M <= 9) {
        M = '0' + M
    }
    let elTimeData = Y.toString() + M.toString()

    // 获取天数
    let date2 = new Date(year, month, 0)
    let days = date2.getDate()
    if (d == days) {
        return elTimeData <= nowDate
    } else {
        return elTimeData < nowDate
    }
}

// uploadBigFile封装中用到的方法（后续删除，用公用方法）
export function timestampToDate(timestamp) {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    return Y + M + D
}
export function timestampToYestoday() {
    let date = new Date() //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    date.setTime(date.getTime() - 24 * 60 * 60 * 1000)
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    return Y + M + D
}

//跳转方法
/**
 * 
 *          const sendData = {
                id: 1,
                name: 2,
            }
            tabRouter("customerDetailZhihuan", sendData)
 */
export function tabRouter(name, query) {
    let tabs = JSON.parse(window.localStorage.contentTabs)
    new Vue({ router }).$router.push({ name: name, query: query })
    tabs.forEach((item) => {
        if (item.name === name) {
            item.query = query
        }
    })
    window.localStorage.contentTabs = JSON.stringify(tabs)
}
